var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifiedIconPopup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.5,
    height: 92,
    viewBox: "0 0 99.5 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7296",
    "data-name": "Group 7296",
    transform: "translate(-629.5 -211.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-line",
    transform: "translate(631 213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23241",
    "data-name": "Path 23241",
    d: "M0,0H89V89H0Z",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23242",
    "data-name": "Path 23242",
    d: "M2,6.682A3.708,3.708,0,0,1,5.679,3H72.488a3.681,3.681,0,0,1,3.679,3.682V66.068a3.708,3.708,0,0,1-3.679,3.682H5.679A3.682,3.682,0,0,1,2,66.068Zm7.417,3.734V62.333H68.75V10.417Zm7.417,7.417h22.25v22.25H16.833ZM24.25,25.25v7.417h7.417V25.25ZM16.833,47.5h44.5v7.417h-44.5ZM46.5,17.833H61.333V25.25H46.5Zm0,14.833H61.333v7.417H46.5Z",
    transform: "translate(5.417 8.125)",
    fill: "#4b58ab",
    stroke: "#fff",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7022",
    "data-name": "Group 7022",
    transform: "translate(-119 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_946",
    "data-name": "Rectangle 946",
    transform: "translate(821 255)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 22,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22989",
    "data-name": "Path 22989",
    d: "M19.1,1,33.8,4.267a1.79,1.79,0,0,1,1.4,1.746V23.879a10.733,10.733,0,0,1-4.78,8.931L19.1,40.358,7.78,32.81A10.73,10.73,0,0,1,3,23.881V6.013A1.79,1.79,0,0,1,4.4,4.267Zm7.965,12.92L18.21,22.774l-5.059-5.059-2.53,2.53,7.591,7.591L29.6,16.45Z",
    transform: "translate(812.798 246.642)",
    fill: "#1ec2b1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIconPopup);
export default __webpack_public_path__ + "static/media/verified-icon-popup.0dc6807102a340a377f50927ddea6406.svg";
export { ForwardRef as ReactComponent };